import '@/Components/Form/FormLineBreak.scss';

const FormLineBreak = (): JSX.Element => <div className="layoutDividerLine w-100" />;

export default FormLineBreak;
